import React, { useEffect, useState } from "react"
import Breadcrumb from "../../components/Common/Breadcrumb"
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import {
  FaChevronLeft,
  FaChevronRight,
  FaPen,
  FaPlus,
  FaTrash,
} from "react-icons/fa6"
import { Link } from "react-router-dom"
import Configs from "../../config"
import { Switch } from "antd"
import { CgGym } from "react-icons/cg"
import Swal from "sweetalert2"
import { MdDownload, MdSend, MdWorkOutline } from "react-icons/md"
import Loader from "components/Loader/loader"
import {
  fetchData,
  FetchDeleteData,
  FetchPutData,
} from "utils/Common_api_functions"
import moment from "moment"
import MarketingEmailModal from "./Marketing"
import countryList from "react-select-country-list"
import { IoMdDocument } from "react-icons/io"
import TrainingPlanModal from "./TrainingPlan"

const UserIndex = () => {
  const [loading, setLoading] = useState(false)

  const [userData, setuserData] = useState([])
  const [data, setData] = useState([])

  const [searchString, setSearchString] = useState("")
  const [marketingEmail, setMarketingEmail] = useState(false)

  useEffect(() => {
    if (searchString !== "") {
      const filteredData = data.filter(
        item =>
          item?.name?.toLowerCase().includes(searchString.toLowerCase()) ||
          item?.email?.toLowerCase().includes(searchString.toLowerCase()) ||
          item?.trainingStartDate
            ?.toLowerCase()
            .includes(searchString.toLowerCase()) ||
          item?.country?.toLowerCase().includes(searchString.toLowerCase())
      )
      setuserData(filteredData)
      setPage(1)
    } else {
      setuserData(data)
    }
  }, [searchString, data])

  useEffect(() => {
    getUserData()
  }, [])

  async function getUserData() {
    const APIData = await fetchData(setLoading, "user")
    if (APIData?.success) {
      setuserData(APIData?.users)
      setData(APIData?.users)
    }
  }

  const [page, setPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(50)

  const totalPages = Math.ceil(userData.length / itemsPerPage)
  const finalData = userData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  )

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  const handleDelete = async userId => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the user.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        Swal.fire("Deleted!", "User has been deleted.", "success")
        try {
          const res = await FetchDeleteData(setLoading, "user", userId)

          if (res?.data?.success) {
            Swal.fire("Deleted!", "User has been deleted.", "success")
            getUserData()
          } else {
            Swal.fire(
              "Error",
              res?.data?.message || "Something went wrong.",
              "error"
            )
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "An error occurred while deleting the user.",
            "error"
          )
          console.error(error)
        }
      }
    })
  }

  const handleMarketingEmail = async (status, userid) => {
    const actionText = status ? "enable" : "disable"

    const confirm = await Swal.fire({
      title: `Are you sure you want to ${actionText} marketing emails for this user?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Yes, ${actionText}`,
      cancelButtonText: "Cancel",
      confirmButtonColor: status ? "#28a745" : "#d33",
    })

    if (!confirm.isConfirmed) return

    const APIdata = await FetchPutData(setLoading, "user", userid, {
      allowMarketingEmail: status,
    })

    if (APIdata?.data?.success) {
      Swal.fire({
        icon: "success",
        title: `Marketing emails have been ${
          status ? "enabled" : "disabled"
        } successfully.`,
        timer: 2000,
        showConfirmButton: false,
      })

      // Update local state so Switch reflects the change
      setuserData(prev =>
        prev.map(u =>
          u._id === userid ? { ...u, allowMarketingEmail: status } : u
        )
      )
    } else {
      Swal.fire({
        icon: "error",
        title: "Update failed",
        text:
          APIdata?.data?.message || "Something went wrong. Please try again.",
      })
    }
  }

  const handleStatusChange = async (status, userid) => {
    const actionText = status ? "enable" : "disable"

    const confirm = await Swal.fire({
      title: `Are you sure you want to ${actionText} Access for this user?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Yes, ${actionText}`,
      cancelButtonText: "Cancel",
      confirmButtonColor: status ? "#28a745" : "#d33",
    })

    if (!confirm.isConfirmed) return

    const APIdata = await FetchPutData(setLoading, "user/status", userid, {
      status,
    })

    if (APIdata?.data?.success) {
      Swal.fire({
        icon: "success",
        title: `User Status has been ${
          status ? "enabled" : "disabled"
        } successfully.`,
        timer: 2000,
      })

      // Update local state so Switch reflects the change
      setuserData(prev =>
        prev.map(u => (u._id === userid ? { ...u, status: status } : u))
      )
    } else {
      Swal.fire({
        icon: "error",
        title: "Update failed",
        text:
          APIdata?.data?.message || "Something went wrong. Please try again.",
      })
    }
  }

  const handleExport = () => {
    console.log("All")
    // Construct the full API URL
    const url = `${Configs.baseURL}user/export/all`

    // Open in a new tab
    window.open(url, "_blank")
  }

  const maxVisiblePages = 5

  const startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2))

  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

  const visiblePages = Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  )

  const [selectedTrainingUser, setSelectedTrainingUser] = useState({})
  const [trainingModal, setTrainingModal] = useState(false)

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="Users" />
        {loading && <Loader />}
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Users</h4>
                  <div className="d-flex justify-content-start gap-3">
                    <Badge className="px-3 py-2 fs-6" color="success">
                      Active Users :{" "}
                      {userData?.filter(item => item?.status)?.length}
                    </Badge>
                    <Badge className="px-3 py-2 fs-6" color="warning">
                      InActive Users :{" "}
                      {userData?.filter(item => !item?.status)?.length}
                    </Badge>
                  </div>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input
                        placeholder="Search users"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                    </div>
                    <button
                      className="btn btn-secondary"
                      onClick={() => handleExport()}
                    >
                      <MdDownload size={16} className="me-1" />
                      Export
                    </button>
                    <button
                      className="btn btn-add"
                      onClick={() => setMarketingEmail(true)}
                    >
                      <MdSend size={16} className="me-1" />
                      Markering Email
                    </button>
                    <Link to={`${Configs.appurl}add-user`}>
                      <button className="btn btn-add">
                        <FaPlus className="me-1" size={14} />
                        Add User
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>Name</th>
                        <th>Email</th>
                        {/* <th>Age</th> */}
                        <th>Country</th>
                        <th>Registration Date</th>
                        <th>Training Start</th>
                        <th>Marketing Email</th>
                        <th>Status</th>
                        <th style={{ minWidth: "100px" }}>Actions</th>
                        <th>Training Plan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalData.length === 0 && (
                        <tr>
                          <td colSpan={10} className="text-center">
                            No Users Found
                          </td>
                        </tr>
                      )}
                      {finalData.map((user, index) => (
                        <tr key={user.id}>
                          <td>
                            {userData.length -
                              ((page - 1) * itemsPerPage + index)}
                          </td>
                          <td>{user.name}</td>
                          <td>{user.email}</td>
                          {/* <td>
                            {user?.birthdate
                              ? calculateAge(user.birthdate)
                              : "--"}
                          </td> */}
                          <td>
                            {countryList()
                              ?.getData()
                              ?.find(option => option.value === user?.country)
                              ?.label ||
                              user?.country ||
                              "--"}
                          </td>
                          <td>
                            {user.createdAt
                              ? moment(user.createdAt).format("DD-MM-YYYY")
                              : "--"}
                          </td>
                          <td>
                            {user.trainingStartDate
                              ? moment(user.trainingStartDate).format(
                                  "DD-MM-YYYY"
                                )
                              : "--"}
                          </td>
                          <td>
                            <Switch
                              checked={user.allowMarketingEmail} // controlled value
                              onChange={status =>
                                handleMarketingEmail(status, user?._id)
                              }
                            />
                          </td>
                          <td>
                            <Switch
                              checked={user.status}
                              onChange={status =>
                                handleStatusChange(status, user?._id)
                              }
                            />
                          </td>

                          <td style={{ width: "100px" }}>
                            <Link to={`${Configs.appurl}edit-user/${user._id}`}>
                              <button className="btn btn-sm btn-primary me-2">
                                <FaPen size={12} />
                              </button>
                            </Link>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(user?._id)}
                            >
                              <FaTrash size={12} />
                            </button>
                          </td>
                          <td>
                            {user?.trainingPlans?.filter(
                              item => item.isInserted === false
                            )?.length > 0 && (
                              <button
                                className="btn btn-sm btn-success "
                                onClick={() => {
                                  setSelectedTrainingUser(user),
                                    setTrainingModal(true)
                                }}
                              >
                                <CgGym size={14} />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {finalData.length} out of {userData.length} users.
                  </p>
                  <div className="d-flex flex-wrap">
                    <div className="d-flex flex-wrap">
                      {/* Prev */}
                      <div
                        className="bd-number-pagination me-1"
                        onClick={() => changePage(page - 1)}
                        style={{
                          cursor: "pointer",
                          opacity: page === 1 ? 0.5 : 1,
                        }}
                      >
                        <FaChevronLeft />
                      </div>

                      {/* Page Numbers (5 only) */}
                      {visiblePages.map(p => (
                        <div
                          key={p}
                          className={`bd-number-pagination me-1 ${
                            page === p ? "activepage" : ""
                          }`}
                          onClick={() => changePage(p)}
                          style={{ cursor: "pointer" }}
                        >
                          {p < 10 ? `0${p}` : p}
                        </div>
                      ))}

                      {/* Next */}
                      <div
                        className="bd-number-pagination"
                        onClick={() => changePage(page + 1)}
                        style={{
                          cursor: "pointer",
                          opacity: page === totalPages ? 0.5 : 1,
                        }}
                      >
                        <FaChevronRight />
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <MarketingEmailModal
        marketingEmail={marketingEmail}
        setMarketingEmail={setMarketingEmail}
      />

      <TrainingPlanModal
        isOpen={trainingModal}
        toggle={() => setTrainingModal(false)}
        user={selectedTrainingUser}
        fetchData={getUserData}
      />
    </div>
  )
}

export default UserIndex
